import { useSignal } from "@preact/signals-react"
import { capitalize } from "@mui/material"
import { newOfficePayload } from "Pages/Admin/Users/@signals"

export default function useAdminNewOfficeInfo(value, key) {

	const dataInfo = useSignal(value)

	const setDataInfo = (value) => {
		dataInfo.value = value

		const updatedOfficeFormData = newOfficePayload.peek()

		updatedOfficeFormData[key] = value

		newOfficePayload.value = { ...updatedOfficeFormData }
	}


	return {
		[key]: dataInfo.value,
		[`set${capitalize(key)}Info`]: setDataInfo,
	}
}
